export const AppRoutes = {};

export const HomeRoutes = {};
